import {PlatformType} from "./customEnum";

const getOS = () => {
	let userAgent = window.navigator.userAgent,
		platform = window.navigator.platform,
		macosPlatforms = ['Macintosh', 'MacIntel', 'MacPPC', 'Mac68K'],
		windowsPlatforms = ['Win32', 'Win64', 'Windows', 'WinCE'],
		iosPlatforms = ['iPhone', 'iPad', 'iPod'],
		os = null;

	if (macosPlatforms.indexOf(platform) !== -1) {
		os = PlatformType.macOS;

		try {
			document.createEvent("TouchEvent"); // iPad, it can touch
			os = PlatformType.iOS;
		} catch (e) {}
	} else if (iosPlatforms.indexOf(platform) !== -1) {
		os = PlatformType.iOS;
	} else if (windowsPlatforms.indexOf(platform) !== -1) {
		os = PlatformType.windows;
	} else if (/Android/.test(userAgent)) {
		os = PlatformType.android;
	} else if (!os && /Linux/.test(platform)) {
		os = PlatformType.linux
	}

	return os;
}

export {
	getOS
}
